<template>
    <div class="container">
        <div class="tabs">
            <van-tabs v-model="tabs.active" type="card" color="#3f97fd">
                <van-tab :title="item.label" :name="item.value" v-for="(item, index) in tabs.list" :key="index">
                </van-tab>
            </van-tabs>
        </div>
        <keep-alive>
            <ChatMessage v-if="tabs.active === TabsValue.MESSAGE" />
            <ChatVideo v-else />
        </keep-alive>
        <div class="footer">
            <van-button type="info" @click="$router.back()">关闭</van-button>
        </div>
    </div>
</template>

<script>
import ChatMessage from '@/components/chat/message/index.vue'
import ChatVideo from '@/components/chat/video/index.vue'
const TabsValue = {
    MESSAGE: 0,
    VIDEO: 1
}
export default {
    components: {
        ChatMessage,
        ChatVideo
    },
    data() {
        return {
            TabsValue,
            tabs: {
                active: TabsValue.MESSAGE,
                list: [
                    {
                        label: '图文沟通记录',
                        value: TabsValue.MESSAGE
                    },
                    {
                        label: '视频沟通记录',
                        value: TabsValue.VIDEO
                    }
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #fff;

    .tabs {
        padding: 20px 70px;
        background-color: #fff;
    }
    .footer {
        background: #fff;
        padding: 15px;
        .van-button {
            width: 100%;
            height: 45px;
            line-height: 1;
            border-radius: 6px;
        }
    }
}
</style>